module.exports = __webpack_public_path__ + "img/stx.ba777065.jpg";